export default __webpack_public_path__ + "static/media/CarAndDriver.32694db1.svg";